// src/lib/avis-featured-limit.js
// Plafond de la SÉLECTION d'avis épinglés servie aux pages publiques.
//
// ⚠️ MIROIR CLIENT — la source de vérité est `AVIS_FEATURED_LIMIT` dans
// api/sites.js : c'est ce `.limit()` qui décide réellement combien d'avis
// épinglés la page publique reçoit (annonce logement ET vitrine). CRA
// (ModuleScopePlugin) interdit d'importer api/ depuis src/, d'où ce miroir.
// La parité est PROUVÉE par src/lib/avis-featured-limit.test.js, qui relit la
// constante dans api/sites.js : toute divergence fait rougir la CI.
//
// Raison d'être : l'admin peut épingler autant d'avis qu'il veut (aucun garde-
// fou côté écriture, et c'est voulu — épingler reste non destructif). Sans ce
// miroir, l'écran affichait « 7 en avant » alors que la page publique n'en
// rendait que 6, en silence.

export const AVIS_FEATURED_LIMIT = 6

/**
 * Nombre d'avis épinglés qui ne seront PAS affichés publiquement.
 *
 * @param {number} pinnedCount — avis épinglés sur le périmètre courant.
 * @returns {number} 0 si tout tient dans le plafond, sinon le surplus.
 */
export function avisFeaturedOverflow(pinnedCount) {
  const n = Number(pinnedCount) || 0
  return n > AVIS_FEATURED_LIMIT ? n - AVIS_FEATURED_LIMIT : 0
}
